import api from '../api'

const baseUrl = '/academy/api/AdminCourse'

const dadbanCourseProvider = {
  getAllCourses(params = {}) {
    return api.post(`${baseUrl}/Table`, {
      params,
    })
  },

  getCourse(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  getAllCourseUsers(params = {}) {
    return api.post(`${baseUrl}/CoursePeopleTable`, {
      params,
    })
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },

  addCourse(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateCourse(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteCourse(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  addCoursePrerequisite(params) {
    return api.post(`${baseUrl}/Prerequisite`, params)
  },

  searchCoursePrerequisite(params) {
    return api.post(`${baseUrl}/SearchPrerequisite`, params)
  },

  deleteCoursePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/Prerequisite`, { params })
  },

  updateUserRole(params = {}) {
    return api.put(`${baseUrl}/ProductPeopleRole`, params)
  },
  updateCourseHeadlineOrder(params) {
    return api.put(`${baseUrl}/SessionOrder`, params)
  },

  getAdminClassList(params) {
    return api.get(`${baseUrl}/AdminProductPeople/id?id=${params}`)
  },

  generateLoginUrl(params = {}) {
    return api.post(`/academy/api/Home/LoginUrl`, params)
  },

  getTrainUsers(params) {
    return api.get(`${baseUrl}/PracticePeopleTable/id?id=${params}`)
  },

  updateUserTrainScore(params = {}) {
    return api.put(`${baseUrl}/PracticePeopleScore/id`, params)
  },
  getPractice(id) {
    return api.get(`${baseUrl}/GetPractice/id?id=${id}`)
  },
  editPracticeStatus(params) {
    return api.put(`${baseUrl}/EditPracticeStatus`, params)
  },
  setOrder(params) {
    return api.post(`${baseUrl}/EditCourseOrder`, params)
  },
  getCourseUsersPercentExel(params) {
    return api.post(`${baseUrl}/DownloadCoursePeoplePercentWithDate`, params)
  },
}

export default dadbanCourseProvider
